import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ClientColumn {
    NAME = "name",
    ENTITIES = "entities",
    TEAM = "team",
    MEMBERS = "members",
    ACTIONS = "actions",
    PLAN = "plan",
    START_DATE = "startDate",
    PRICE_MONTHLY = "priceMonthly",
    BILLING_OWNERSHIP = "billingOwnership",
    SERVICES = "services",
    NOTE = "note",
    LEGAL_TYPE = "legalType",
    SUBSCRIPTION_START_DATE = "subscriptionStartDate",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.ENTITIES),
});
export type EntitiesColumn = z.infer<typeof EntitiesColumnSchema>;

const TeamColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.TEAM),
});
export type TeamColumn = z.infer<typeof TeamColumnSchema>;

const MembersColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.MEMBERS),
});
export type MembersColumn = z.infer<typeof MembersColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.ACTIONS),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

const PlanColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.PLAN),
});
export type PlanColumn = z.infer<typeof PlanColumnSchema>;

const StartDateColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.START_DATE),
});
export type StartDateColumn = z.infer<typeof StartDateColumnSchema>;

const PriceMonthlyColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.PRICE_MONTHLY),
});
export type PriceMonthlyColumn = z.infer<typeof PriceMonthlyColumnSchema>;

const BillingOwnershipColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.BILLING_OWNERSHIP),
});
export type BillingOwnershipColumn = z.infer<
    typeof BillingOwnershipColumnSchema
>;

const ServicesColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.SERVICES),
});
export type ServicesColumn = z.infer<typeof ServicesColumnSchema>;

const NoteColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.NOTE),
});
export type NoteColumn = z.infer<typeof NoteColumnSchema>;

const LegalTypeColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.LEGAL_TYPE),
});
export type LegalTypeColumn = z.infer<typeof LegalTypeColumnSchema>;

const SubscriptionStartDateColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.SUBSCRIPTION_START_DATE),
});
export type SubscriptionStartDateColumn = z.infer<
    typeof SubscriptionStartDateColumnSchema
>;

export const ClientViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CLIENT),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            EntitiesColumnSchema,
            TeamColumnSchema,
            MembersColumnSchema,
            ActionsColumnSchema,
            PlanColumnSchema,
            StartDateColumnSchema,
            PriceMonthlyColumnSchema,
            BillingOwnershipColumnSchema,
            ServicesColumnSchema,
            NoteColumnSchema,
            LegalTypeColumnSchema,
            SubscriptionStartDateColumnSchema,
        ]),
    ),
});

export type ClientView = z.infer<typeof ClientViewSchema>;
